













































import { Vue, Component } from "vue-property-decorator";
import DCard from "@/views/warning/components/DCard.vue";
import { API_BIS_REPORT_STAT, API_WARNING } from "@/configs/Apis";
import { WARNING_PROJECT_ID, TECH_FIELD, COMP_FIELD } from "@/app-data/warning/warning";
import ReportTable from "@/views/report/ReportTable.vue";
import ReportChart from "@/views/report/ReportChart.vue";
import Ajax from "@/utils/DuduAjax";

import cloneDeep from "lodash/cloneDeep";

import appCountModel from "@/app-data/report/models/overview/appCount";
import { RequestConfig } from "@/types";

@Component({ components: { DCard, ReportTable, ReportChart } })
export default class Index extends Vue {
  subjectNa = "国内";

  requests: { [k: string]: RequestConfig } = {
    techSummary: {
      api: { url: `${API_WARNING}?category=${TECH_FIELD}&UC=1`, path: {} },
      loading: false,
      params: () => {
        return {
          items: [{
            name: TECH_FIELD,
            operator: "NOT_NULL"
          }]
        };
      },
      method: "POST",
      callback: this.processTableData.bind(this),
      data: []
    },
    compSummary: {
      api: { url: `${API_WARNING}?category=${COMP_FIELD}&UC=1`, path: {} },
      loading: false,
      params: () => {
        return {
          items: [{
            name: COMP_FIELD,
            operator: "NOT_NULL"
          }]
        };
      },
      method: "POST",
      callback: this.processTableData.bind(this),
      data: []
    },
    tech: {
      api: { url: API_BIS_REPORT_STAT + "?UC=1", path: {} },
      loading: false,
      params: (function () {
        const config: any = cloneDeep(appCountModel.definition);
        delete config.rowDims[0].needTotal;
        (config.rowDims[0] as any).limit = 10;

        config.condition = {
          items: [{
            name: TECH_FIELD,
            operator: "NOT_NULL"
          }]
        };

        return config;
      })(),
      method: "POST",
      callback: this.processChartData.bind(this),
      data: {},
      extra: { model: appCountModel, chartOption: {} }
    },
    comp: {
      api: { url: API_BIS_REPORT_STAT + "?UC=1", path: {} },
      loading: false,
      params: (function () {
        const config: any = cloneDeep(appCountModel.definition);
        delete config.rowDims[0].needTotal;
        (config.rowDims[0] as any).limit = 10;

        config.condition = {
          items: [{
            name: COMP_FIELD,
            operator: "NOT_NULL"
          }]
        };

        return config;
      })(),
      method: "POST",
      callback: this.processChartData.bind(this),
      data: {},
      extra: { model: appCountModel, chartOption: {} }
    }
  };

  mounted() {
    this.processRequestData();
  }

  get projectId() {
    return WARNING_PROJECT_ID;
  }

  processRequestData() {
    const requests = this.requests;
    Object.keys(requests).forEach(name => {
      (async () => {
        const config = requests[name];
        try {
          if (config.once === true && (config as any).__loaded === true) {
            return;
          }
          config.loading = true;
          let params;
          if (typeof config.params === "function") {
            params = (config.params as (this: Vue) => any).call(this as any);
          } else {
            params = config.params;
          }
          if (!Object.prototype.hasOwnProperty.call(config.api.path, "projectId")) {
            config.api.path.projectId = this.projectId;
          }
          const res = await Ajax.queryData(config.api, params, config.method, false, false);
          if (config.callback && typeof config.callback === "function") {
            config.callback.call(this, res, config);
          }
        } finally {
          config.loading = false;
          if (config.once === true) {
            (config as any).__loaded = true;
          }
        }
      })();
    });
  }

  processTableData(res: any, config: RequestConfig) {
    const title = (config.api.url.indexOf(`category=${TECH_FIELD}`) >= 0) ? "技术主题" : "竞争对手";
    config.data = {
      title: `${title} (共 ${res.cnt || 0} 个)`,
      data: [
        { value1: "国内申请专利", value2: res.cn || 0, value3: "国外申请专利", value4: res.ab || 0 },
        { value1: "当前有效专利", value2: res.auth || 0, value3: "今年新增申请", value4: res.app || 0 },
        { value1: "今年新增授权", value2: res.pub || 0, value3: "", value4: "" },
        { value1: "按专利类型统计", value2: "", value3: "", value4: "" },
        { value1: "发明专利", value2: res.fm || 0, value3: "实用新型", value4: res.syxx || 0 },
        { value1: "外观", value2: res.wg || 0, value3: "", value4: "" }
      ]
    };
  }

  processChartData(data: any, config: RequestConfig) {
    config.data = data;
    const model = config.extra?.model;
    if (model) {
      config.extra.chartOption = model.chart(config.params, model, data);
    }
  }
};
